module.exports = __webpack_public_path__ + "static/media/logo-openium-m-white.0f6f3ddb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/openium/logo-openium-m-white.svg
// module id = ./src/resources/images/openium/logo-openium-m-white.svg
// module chunks = 0